'use strict';

userService.$inject = ["$http", "api", "User"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userService = userService;
/*@ngInject*/
function userService($http, api, User) {
    return {
        getById: getById,
        getMyAccount: getMyAccount,
        setBuyerMail: setBuyerMail,
        setBuyerMailLanguage: setBuyerMailLanguage,
        getCurrentTenant: getCurrentTenant
    };

    function getById(id) {
        return $http.get('/assets/data/user-' + id + '.json').then(function (response) {
            var resource = response.data;
            return resource;
        });
    }

    function getMyAccount() {
        return api.myAccount.get().$promise.then(function (response) {
            return User.create(response);
        });
    }

    function setBuyerMail(mail) {
        return api.setBuyerMail.execute({ mail: mail }).$promise;
    }

    function setBuyerMailLanguage(language) {
        return api.setBuyerMailLanguage.execute({ id: language.id }).$promise;
    }

    function getCurrentTenant() {
        return api.currentTenant.get().$promise.then(function (resource) {
            return resource;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/userService.js
// module id = 833
// module chunks = 0